import { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';

import { config } from '@/config/env.ts';

export const WaitlistModal = ({ onClose }: { onClose: () => void }) => {
	const handleKeyDown = useCallback(
		(e: KeyboardEvent) => {
			if (e.key === 'Escape') onClose();
		},
		[onClose],
	);

	useEffect(() => {
		document.documentElement.style.overflow = 'hidden';
		document.body.style.overflow = 'hidden';
		document.addEventListener('keydown', handleKeyDown);
		return () => {
			document.documentElement.style.overflow = '';
			document.body.style.overflow = '';
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [handleKeyDown]);

	return createPortal(
		<div
			className="fixed inset-0 z-[200] flex items-center justify-center
				bg-black/40 p-5 backdrop-blur-md sm:p-10"
			onClick={(e) => {
				if (e.target === e.currentTarget) onClose();
			}}
		>
			<div
				className="h-full w-full overflow-hidden rounded-xl bg-white shadow-2xl"
			>
				<iframe
					src={config.WAITLIST_URL}
					className="h-full w-full border-0"
					title="Join the Project Bridgeway waitlist"
				/>
			</div>
		</div>,
		document.body,
	);
};
